export default {"src":"/_next/static/media/flag-BR.d58e5fa4.svg","height":18,"width":24,"blurWidth":0,"blurHeight":0};